/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */

import * as og from 'og';
import * as SNAP_HELPER from './snap_helper.js';

const {XYZ, WMS, Vector} = og.layer;
const {LonLat} = og;
const {Selection,
    SelectionScene,
    GeoImageDragControl,
    Control,
    UIhelpers,
    ZoomControl,
    TouchNavigation,
    EarthNavigation,
    MouseNavigation,
    MouseWheelZoomControl,
    ScaleControl,
    CompassButton,
    SimpleSkyBackground,
    // EarthCoordinates

} = og.control;






class SnapGlobe {

    #globe;
    #options;
    
    get globe() {
        return this.#globe;
    }

    #exclusiveControls = {}

    get isInitialized() {
        return this.#globe.planet._initialized;
    }

    constructor(options) {
        this.#options = options || {};
        this.#addBaseControls();
        //se mi dovessi dimenticare con copia incolla
        this.#initGlobe();


    }

    #initGlobe() {
        this.#globe = new og.Globe(this.#options);
    }

    #addBaseControls() {
        this.#options.controls = [
            new MouseNavigation(),
            new TouchNavigation(),
            new SNAP_HELPER.EarthCoordinates({
                type: 0,
                centerMode: false
            }),
            new ScaleControl(),
            new CompassButton({
                //'svg': svg
            }),
            new SimpleSkyBackground()
        ];
    }

    //aggiungo i controlli che devono essere attivi in modo esclusivo
    addExclusiveControl(id, control) {
        this.#globe.planet.addControl(control);
        this.#exclusiveControls[id] = control;

    }

    deactivateAllExclusiveControls() {
        Object.values(this.#exclusiveControls).forEach(function (control) {
            control.setActive(false);
        });
    }
    activateExclusiveControl(id) {
        if (this.#exclusiveControls[id]) {
            this.#exclusiveControls[id].setActive(true);
        }
    }

}


export {SnapGlobe};